import { backButtonCust, resubmitCust, withCommas, payFrequencyChange, updateNextPayDateFormGroupForPayFrequency, updateFollowingPayDateFormGroupForPayFrequency, sendForm, otfValidate, roundLoanAmount} from "./form-functions";
import { setupQuoteboost, updateQuoteBoost } from "./quoteboost";
import "./form-events.js";

// getPermissionPopoverText, 
var animation = false,
    animationstring = 'animation',
    keyframeprefix = '',
    domPrefixes = 'Webkit Moz O ms Khtml'.split(' '),
    pfx = '',
    elem = document.createElement('div');

window.toggleFinanceBreakdown = function (show) {
    show = show || false;
    var expenditureFormGroup = $('.expenditure-form-group');
    var otherOutgoingBreakdown = $('.other-outgoings-breakdown');
    if (show) {
        if (otherOutgoingBreakdown.is(':hidden')) {
            expenditureFormGroup.velocity('finish').velocity('slideUp', {
                duration: 500
            });
            otherOutgoingBreakdown.velocity('finish').velocity('slideDown', {
                duration: 500
            });
        }
    } else {
        var financeFields = $('.finance-fields');
        financeFields.val(0);
        var expenseTotal = $('#expensesTotal');
        expenseTotal.html('£0');
        if (otherOutgoingBreakdown.is(':visible')) {
            expenditureFormGroup.velocity('finish').velocity('slideDown', {
                duration: 500
            });
            otherOutgoingBreakdown.velocity('finish').velocity('slideUp', {
                duration: 500
            });
        }
    }
};

if (elem.style.animationName !== undefined) {
    animation = true;
}

if ($('.header-form-strip-facebook').hasClass('white-cta-main')) {
    $('.header-form-strip-facebook').addClass('fs-xs-black');
} else {
    $('.header-form-strip-facebook').addClass('fs-xs-white');
}

if ($('body').is('.cccOverlay')) {
    var cccOverlay = $('.ccc-redirect-overlay');
    cccOverlay.addClass('show');
    
    $('.ccc-popup-close').click(function(){
        cccOverlay.removeClass('show');
        $('.ccc-redirect-overlay').hide();
    });
    
    var cccId = $('[name=cccid]').val();
    // $('#cccRedirect').attr("href", "https://www.compare-credit-cards.com/results/"+cccId);
    $('#cccRedirect').attr("href", cccId);

    setTimeout(function(){
        if (cccOverlay.hasClass('show')) {
            // location.href = 'https://www.compare-credit-cards.com/results/'+cccId;
            location.href = cccId;
        }
    }, 3000);
}

var formPageTermBlockout = function(form, value) {
    value = parseInt(value);
    // Block out terms if the value has invalidated the terms
    var term = form.find('[name=term]');
    var options = term.find('option');
    var termVal = parseInt(term.val());
    var initialMap = (function() {
        var map = {};
        options.each(function(i, o) {
            var option = $(o);
            map[option.attr('value')] = option.prop('disabled');
        });
        return map;
    })();
    var rebuildJsDropDowns = false;
    var updateTerms = function(map) {
        if (map !== initialMap) {
            rebuildJsDropDowns = true;
            var k;
            for (k in map) {
                options.filter('[value=' + k + ']').prop('disabled', map[k]);
            }
        }
    };
    if (value < 1000) {
        updateTerms({ 3: false, 6: false, 12: false, 18: true, 24: true, 36: true });
        if (termVal >= 18) {
            // Change term to 12
            otfValidate(term.val(12));
            rebuildJsDropDowns = true;
        }
    } else if (value === 1000) {
        // Unlock 3 6 12 18 24 36
        updateTerms({ 3: false, 6: false, 12: false, 18: false, 24: false, 36: false });
    } else if (value > 1000 && value < 2000) {
        // Unlock 6 12 18 24 36
        updateTerms({ 3: true, 6: false, 12: false, 18: false, 24: false, 36: false });
        // Lock 3
        if (termVal == 3) {
            // Chnage term to 6
            otfValidate(term.val(6));
            rebuildJsDropDowns = true;
        }
    } else {
        updateTerms({ 3: true, 6: true, 12: false, 18: false, 24: false, 36: false });
        if (termVal < 12) {
            // Chnage term to 12
            otfValidate(term.val(12));
            rebuildJsDropDowns = true;
        }
    }
    if (rebuildJsDropDowns === true) {
        if (window.innerWidth > 991) {
            // Select2
        } else {
            // Digi Picker
            term.picker('destroy');
            term.picker();
        }
    }
};

if (animation === true) {
    for (var i = 0; i < domPrefixes.length; i++) {
        if (elem.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
            pfx = domPrefixes[i];
            animationstring = pfx + 'Animation';
            keyframeprefix = '-' + pfx.toLowerCase() + '-';
            animation = true;
            break;
        }
    }
}

if (animation === true) {
    $('body').addClass('no-keyframe');
}

window.journey = $('[name=journey_type]').length > 0 ? $('[name=journey_type]').val() : '';

window.dataLayer = window.dataLayer || [];
dataLayer.push({
    'event': 'form',
    'formType': window.journey,
    'formPage': 1
});

$(document).ready(function () {
    if ($('body').is('.returning')) {
        var url = $('[name=redirectUrl]').val();
        location.href = url;
    }

    $(document).on('beforevalidate.digiloans', '[name=loan_amount]', function(event){
        event.stopImmediatePropagation();
        var target = $(event.currentTarget);
        var form = target.closest('form');
        var value = roundLoanAmount(target.val());
        target.val(value);
        otfValidate(target);
        formPageTermBlockout(form, value);
        updateQuoteBoost();


        // var el = $(event.currentTarget);
        // el.val(roundLoanAmount(el.val()));
        // otfValidate(el);


        //var form = el.closest('form');
        // var loanAmount = form.find('[name=loan_amount]');
        // loanAmount.val(el.val().replace('£', ''));
        // loanAmount.trigger('beforevalidate.digiloans');
    });
    setupQuoteboost();

    $(document).on('keyup', '[name=income]', function (event) {
        var monthlyIncome = $(this).val();
        var annualIncome = monthlyIncome * 12;
        $('.monthly-income-value-text').text('£' + withCommas((annualIncome).toFixed(2)));
        // if (annualIncome >= 1000) {
        //     $('.monthly-income-form-group').slideDown();
        // }
    });

    $(document).on('change', '[name=utilities], [name=transport], [name=food], [name=personal], [name=expense]', function(event){
        var target = $(event.target);
        var form = target.closest('form');
        var utilities = form.find('[name=utilities]');
        utilities = parseInt(utilities.length == 1 ? (utilities.val() || 0) : 0, 10);
        var transport = form.find('[name=transport]');
        transport = parseInt(transport.length == 1 ? (transport.val() || 0) : 0, 10);
        var food = form.find('[name=food]');
        food = parseInt(food.length == 1 ? (food.val() || 0) : 0, 10);
        var personal = form.find('[name=personal]');
        personal = parseInt(personal.length == 1 ? (personal.val() || 0) : 0, 10);
        var expense = form.find('[name=expense]');
        expense = parseInt(expense.length == 1 ? (expense.val() || 0) : 0, 10);
        var outgoings = utilities + transport + food + personal + expense;
        $('#expensesTotal').html('<b>£'+outgoings+'</b>');
        $('input[name=expenditure]').val(outgoings);
    });
    
    if ($('body').is('.home')) {
        $('#home_amount_picker').on('show.bs.modal', function (event) {
            $('.modal .modal-content').css('overflow-y', 'auto');
            $('.modal .modal-content').css('height', $(window).height() * 0.95);
        });
        $(".who-we-are-footer-link").click(function () {
            $('html, body').animate({
                'scrollTop': $('#who-we-are-section').offset().top - 40
            }, 0.1);
        });
        $(window).load(function () {
            // Remove the # from the hash, as different browsers may or may not include it
            var hash = location.hash.replace('#', '');
            if (hash != '') {
                // Clear the hash in the URL
                // location.hash = '';   // delete front "//" if you want to change the address bar
                $('html, body').animate({
                    scrollTop: $('#who-we-are-section').offset().top - 40
                }, 0.1);
            }
        });
    } else {
        $(".who-we-are-footer-link").click(function () {
            window.location.href = "/#who-we-are";
        });
    }

    // setTimeout(function () {
    //     $('#cookie-popup').hide();
    // }, 10000);

    $(document).on('click', '.edit-details-button', function (event) {
        $('.form-group-edit-details').slideToggle();
    });

    $(document).on('click', '.form-field .edit-button', function (event) {
        var button = $(event.target);
        var formField = button.closest('.form-field');
        var formGroup = formField.closest('.form-group');
        if (formField.length != 0) {
            var formFieldEdit = formField.find('.form-field-edit');
            var formFieldDisplay = formField.find('.form-field-display');
        }
        if (formGroup.is('.house-form-group')) {
            var form = formGroup.closest('form');
            form.find('.address1-form-group, .address2-form-group, .town-form-group, .county-form-group, .postcode-form-group, .findaddress-form-group').removeClass('hidden');
        }
    });

    $(document).on('change', '[name=next_pay_date_mobile], [name=following_pay_date_mobile]', function(event){
        var target = $(event.currentTarget);
        var form = target.closest('form');
        if(target.is('[name=next_pay_date_mobile]')){
            form.find('[name=next_pay_date]').val(target.val()).trigger('change');
        }
        if(target.is('[name=following_pay_date_mobile]')){
            form.find('[name=following_pay_date]').val(target.val()).trigger('change');
        }
    });

    // Pseudo select info boxes
    $(document).on('focus blur', '.form-group .form-field input, .pseudo-select', function (event) {
        // Only do any of this if we're on desktop
        if (matchMedia('(min-width: 768px)').matches) {
            var input = $(event.target);
            var formGroup = input.closest('.form-group');
            if (input.is('[name=following_pay_date]')) {
                formGroup = input.closest('form').find('.next_pay_date-form-group');
            }
            var tipText = formGroup.find('.tip-text-container');
            $('.tip-text-container.in').removeClass('in');
            if (tipText.length == 1) {
                tipText.toggleClass('in', event.type === 'focusin');
            }
        }
    });

    $(document).on('mouseenter mouseleave', '.form-group', function (event) {
        var target = $(event.currentTarget);
        if (target.is('.following_pay_date-form-group')) {
            var form = target.closest('form');
            target = form.find('.next_pay_date-form-group');
        }
        // Only do any of this if we're on desktop
        if (matchMedia('(min-width: 768px)').matches) {
            if (target.find('.tip-text-container.fade-md').length > 0) {
                setTimeout(function () {
                    target.find('.tip-text-container.fade-md').toggleClass('in', event.type == 'mouseenter');
                }, target.is('.are-you-sure') ? 3000 : 0);
            }
        }
    });

    // Marital status change handler
    $(document).on('change', '#marital_status', function () {
        // commented the below out so that all marital statuses show the combined pay form group
        // var maritalSatusVal = $('#marital_status').val();
        // if (maritalSatusVal === 'Married') {
        //     $('.combined-pay-form-group').removeClass('hidden');
        // } else {
        //     $('.combined-pay-form-group').addClass('hidden');
        // }
        $('.combined-pay-form-group').removeClass('hidden');
    });

    $(document).on('keydown', '.pseudo-select', function (event) {
        // Return or space
        if (event.keyCode === 13 || event.keyCode === 32) {
            var select = $(event.target);
            select.click();
            var tabbables = $('select,input,.pseudo-select').not('[type=hidden]');
            event.preventDefault();
            for (var i = tabbables.index(select) + 1; i < tabbables.length; i++) {
                var $this = $(tabbables[i]);
                var isPseudoSelect = $this.is('.pseudo-select');
                if (isPseudoSelect) {
                    var thisFormGroup = $this.closest('.form-field');
                    var selectFormField = select.closest('.form-field');
                    if (!thisFormGroup.is(selectFormField)) {
                        $this.focus();
                        return;
                    }
                } else {
                    $this.focus();
                    return;
                }
            }
        }
    });

    $(".terms-privacy-checkbox").click(function () {
        $("label[for='termsconditions']").removeClass('form-error');
        $(".terms-privacy-checkbox").toggleClass("terms-privacy-checkbox-active");
        if ($(".terms-privacy-checkbox").hasClass("terms-privacy-checkbox-active")) {
            $('#termsconditions').val(1);
        } else {
            $('#termsconditions').val(0);
        }
    });

    $(".checkbox-container").click(function () {
        $(".checkbox-container").removeClass('field-error');
        $("label[for='termsconditions']").removeClass('form-error');
        $(".checkbox-1").toggleClass("checkbox-active");
        if ($(".checkbox-1").hasClass("checkbox-active")) {
            $('#termsconditions').val(1);
        } else {
            $('#termsconditions').val(0);
        }
    });

    $(".marketing-checkbox").click(function () {
        $(".marketing-checkbox").toggleClass("active");
        if ($(".marketing-checkbox").hasClass("active")) {
            $('[name=marketing]').val(1);
        } else {
            $('[name=marketing]').val(0);
        }
    });

    // $(".remarketing-checkbox").click(function() {
    //     $(".remarketing-checkbox").toggleClass("active");
    //     if ($(".remarketing-checkbox").hasClass("active")) {
    //         $('[name=remarketing]').val(1);
    //     } else {
    //         $('[name=remarketing]').val(0);
    //     }
    // });

    // Marketing permissions buttons

    $(".permission-button").click(function () {
        $(this).toggleClass('active');
    });

    $(".permission-button.email").click(function () {
        if (!$(this).hasClass("active")) {
            $('[name=marketing_email]').val(0);
        } else {
            $('[name=marketing_email]').val(1);
        }
    });

    $(".permission-button.sms").click(function () {
        if (!$(this).hasClass("active")) {
            $('[name=marketing_sms]').val(0);
        } else {
            $('[name=marketing_sms]').val(1);
        }
    });

    $(".permission-button.telephone").click(function () {
        if (!$(this).hasClass("active")) {
            $('[name=marketing_telephone]').val(0);
        } else {
            $('[name=marketing_telephone]').val(1);
        }
    });

    $(".permission-button.post").click(function () {
        if (!$(this).hasClass("active")) {
            $('[name=marketing_post]').val(0);
        } else {
            $('[name=marketing_post').val(1);
        }
    });

    // $(".cash-advance-checkbox").click(function() {
    //     $(".cash-advance-checkbox").toggleClass("cash-advance-checkbox-active");
    //     if ($(".cash-advance-checkbox").hasClass("cash-advance-checkbox-active")) {
    //         $('[name=cash_advance]').val("Y");
    //     } else {
    //         $('[name=cash_advance]').val("N");
    //     }
    // });

    if ($('body').is('.reapply')) {
        var addressSummaryFormGroup = $('.address_summary-form-group');
        var addressSummary = $('.address-summary');
        var addressSummaryFormGroup2 = $('.address_summary_2-form-group');
        var addressSummary2 = $('.address-summary_2');
        var timeAtAddress = $('[name=time_at_address]').val();

        addressSummaryFormGroup.removeClass('hidden').addClass('in');
        addressSummary.show();

        if (timeAtAddress <= 24 && timeAtAddress != '') {
            addressSummaryFormGroup2.removeClass('hidden').addClass('in');
            addressSummary2.show();    
        }
    }
    if ($('body').is('.prepop')) {
        document.addressSelected = true;
        var addressSummaryFormGroup = $('.address_summary-form-group');
        var timeAtAddress = $('[name=time_at_address]').val();
        addressSummaryFormGroup.removeClass('hidden').addClass('in');

        if (timeAtAddress <= 24 && timeAtAddress != '') {
            document.addressSelected = true;
            $('[name=time_at_address]').trigger('change');
        }
    }
    // Credit card form button click
    $(".next-btn").click(function (e) {
        e.preventDefault();
        if ((document.nextButtonClicked || false) === true) {
            return;
        }
        var datapage = $(this).attr('data-page');
        $(this).addClass('loading');
        document.nextButtonClicked = true;
        sendForm('#' + datapage);
    });
    
    // when home_status is changed update the title so it matches with chosen input selection either 'rent' or 'mortgage'
    $("#dynamicHomeStatus").change(function (e) {
        //array of ids that match the input tiles in the home_status.blade.php file that are to be translated to a mortgage title
        const mortgageIds = ['2', '4'];
        //array of ids that match the input tiles in the home_status.blade.php file that are to be translated to a rent title
        const rentIds = ['1', '3', '5', '6'];
        var selectedHomeStatus = document.querySelectorAll('#dynamicHomeStatus')[0].value;
        if (mortgageIds.includes(selectedHomeStatus)){
            document.querySelectorAll('#housingLabel')[0].innerHTML = 'Monthly Mortgage';
        }
        if (rentIds.includes(selectedHomeStatus)){
            document.querySelectorAll('#housingLabel')[0].innerHTML = 'Monthly Rent';
        }
    });

    $(document).on('change', '[name=primary_income]', function (event) {
        var input = $(event.target);
        var value = input.val();
        var form = input.closest('form');
        var industryField;
        if (value == 'unemployed' || value == 'benefits') {
            $('.employername-form-group').velocity('finish').velocity('slideUp', {
                duration: 500
            });
            $('.industry-form-group').velocity('finish').velocity('slideUp', {
                duration: 500
            });
            $('.job_title-form-group').velocity('finish').velocity('slideUp', {
                duration: 500
            });
            $('.time_in_work-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            $('.pay_frequency-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            $('.next_pay_date-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            $('.following_pay_date-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            $('.net_pay-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            form.find('[name=employer_name]').val('Benefits');
            industryField = form.find('.form-field[data-update-field=industry]');
            industryField.find('.pseudo-select[data-value=other_not_office_based]').click();
            form.find('[name=job_title]').val('On Benefits');
        } else if (value == 'retired') {
            $('.employer_name-form-group').velocity('finish').velocity('slideUp', {
                duration: 500
            });
            $('.industry-form-group').velocity('finish').velocity('slideUp', {
                duration: 500
            });
            $('.job_title-form-group').velocity('finish').velocity('slideUp', {
                duration: 500
            });
            $('.time_in_work-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            $('.pay_frequency-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            $('.next_pay_date-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            $('.following_pay_date-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            $('.net_pay-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            form.find('[name=employer_name]').val('Pension');
            industryField = form.find('.form-field[data-update-field=industry]');
            industryField.find('.pseudo-select[data-value=other_not_office_based]').click();
            form.find('[name=job_title]').val('Pension');
        } else if (value == 'emp_self') {
            $('.employer_name-form-group').velocity('finish').velocity('slideUp', {
                duration: 500
            });
            $('.industry-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            $('.job_title-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            $('.time_in_work-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            $('.pay_frequency-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            $('.next_paydate-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            $('.following_paydate-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            $('.net_pay-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            form.find('[name=employername]').val('Self');
            form.find('[name=job_title]').val('');
        } else if (value == 'student_unemployed') {
            $('.employer_name-form-group').velocity('finish').velocity('slideUp', {
                duration: 500
            });
            $('.industry-form-group').velocity('finish').velocity('slideUp', {
                duration: 500
            });
            $('.job_title-form-group').velocity('finish').velocity('slideUp', {
                duration: 500
            });
            $('.time_in_work-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            $('.pay_frequency-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            $('.next_paydate-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            $('.following_paydate-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            $('.net_pay-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            form.find('[name=employer_name]').val('Student');
            industryField = form.find('.form-field[data-update-field=industry]');
            industryField.find('.pseudo-select[data-value=other_not_office_based]').click();
            form.find('[name=job_title]').val('Student');
        } else if (value == 'student') {
            $('.employer_name-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            $('.industry-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            $('.job_title-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            $('.time_in_work-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            $('.pay_frequency-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            $('.next_pay_date-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            $('.following_pay_date-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            $('.net_pay-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            form.find('[name=employername]').val('');
            form.find('[name=job_title]').val('');
        } else if (value == 'emp_fulltime' || value == 'emp_parttime' || value == 'emp_temporary') {
            $('.employer_name-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            $('.industry-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            $('.job_title-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            $('.time_in_work-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            $('.pay_frequency-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            $('.next_pay_date-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            $('.following_pay_date-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            $('.net_pay-form-group').velocity('finish').velocity('slideDown', {
                duration: 500
            });
            form.find('[name=employer_name]').val('');
            form.find('[name=industry]').val('');
            industryField = form.find('.form-field[data-update-field=industry]');
            industryField.find('.pseudo-selected').removeClass('pseudo-selected');
            form.find('[name=job_title]').val('');
        } else {}
        if (value !== 'error') {
            updateEmployerNameFormGroupForPrimaryIncome(value, form);
            updateJobTitleFormGroupForPrimaryIncome(value, form);
            updateIndustryFormGroupForPrimaryIncome(value, form);
            updateTimeInWorkFormGroupForPrimaryIncome(value, form);
            updatePayFrequencyFormGroupForPrimaryIncome(value, form);
            updateNextPayDateFormGroupForPrimaryIncome(value, form);
            updateFollowingPayDateFormGroupForPrimaryIncome(value, form);
            updateNetPayFormGroupForPrimaryIncome(value, form);
        }
    });

    $(".quickcheck-btn").click(function () {
        $('.form-section-1').velocity('scroll', { duration: 800, offset: -30, easing: 'ease-in-out' });
    });
});

$(document).on('change', '[name=pay_frequency]', function (event) {
    var input = $(event.target);
    var value = input.val();
    if (typeof Raven !== 'undefined') {
        Raven.captureBreadcrumb({
            message: 'Changed pay frequency',
            category: 'action',
            data: {
                value: value
            }
        });
    }
    var form = input.closest('form');
    payFrequencyChange(form);
    if (value !== 'error') {
        updateNextPayDateFormGroupForPayFrequency(value, form);
        updateFollowingPayDateFormGroupForPayFrequency(value, form);
    }
});

if ($('body').is('.loanform')) { 
    var utilities = $('[name=utilities]').val();
    var food = $('[name=food]').val();
    var transport = $('[name=transport]').val();
    var expense = $('[name=expense]').val();
    var employmentStatus = $('[name=employmentStatus]').val(); 

    if (utilities == '0' && food == '0' && transport == '0' && expense == '0') {
        $('.loanform').find($('.loan-expenditure').css('display', 'block'));
    } else {
        $('.loanform').find($('.loan-expenditure').css('display', 'none'));
    }

    if (employmentStatus == '1' || employmentStatus == '2') {
        $('.time_in_work-form-group').addClass('default');
        $('.following_pay_date-form-group').addClass('default');
    } else if (employmentStatus == '5') {
        $('[name=employer_name]').val('Student');
        $('.employer_name-form-group').hide();
        $('[name=industry]').val('other_not_office_based');
        $('.industry-form-group').hide();
        $('.time_in_work-form-group').addClass('student');
        $('.following_pay_date-form-group').addClass('default');
        $('.pay_frequency-form-group').addClass('student');
        $('.next_pay_date-form-group').addClass('default');
        $('#help-text-2').removeClass('hidden').slideDown(250);
        $('#help-text-1').slideUp(250);
    } else if (employmentStatus == '3') { 
        $('.time_in_work-form-group').addClass('emp_self');
        $('.following_pay_date-form-group').addClass('default');
    } else if (employmentStatus == '4') { 
        $('[name=employer_name]').val('Homemaker');
        $('.employer_name-form-group').hide();
        $('[name=industry]').val('other_not_office_based');
        $('.industry-form-group').hide();
        $('.time_in_work-form-group').addClass('homemaker');
        $('.pay_frequency-form-group').addClass('homemaker');
    } else if (employmentStatus == '6') {
        $('[name=employer_name]').val('Benefits');
        $('.employer_name-form-group').hide();
        $('[name=industry]').val('other_not_office_based');
        $('.industry-form-group').hide();
        $('.time_in_work-form-group').addClass('benefits');
        $('.following_pay_date-form-group').addClass('benefits');
        $('.pay_frequency-form-group').addClass('benefits');
        $('.next_pay_date-form-group').addClass('benefits');
        $('#help-text-10').removeClass('hidden').slideDown(250);
        $('#help-text-12').slideUp(250);
    } else if (employmentStatus == '7') {
        $('[name=employer_name]').val('Pension');
        $('.employer_name-form-group').hide();
        $('[name=industry]').val('other_not_office_based');
        $('.industry-form-group').hide();
        $('.time_in_work-form-group').addClass('retired');
        $('.following_pay_date-form-group').addClass('retired');
        $('.pay_frequency-form-group').addClass('retired');
        $('.next_pay_date-form-group').addClass('retired');
    }
}

//Stop Button for Return Customer functionality
$('#stop-btn').click(function(){
    backButtonCust();
});

if ($('body').is('.returnCustomer')) { 
    $('.form-sections-col').hide();
    $('.header-form-container').hide();
    $('.form-sections-wrapper').hide();
    $('.return-customer-section').removeClass('hidden');
}

//employment status help text slider logic
$('#employment-option-5').on('click', function (event) {
    $('#help-text-1').slideUp(250);
    $('#help-text-2').slideDown(250);
    $('#help-text-4').slideUp(250);
})
$('#employment-option-6').on('click', function (event) {
    $('#help-text-1').slideDown(250);
    $('#help-text-2').slideUp(250);
    $('#help-text-4').slideUp(250);
})
$('#employment-option-8').on('click', function (event) {
    $('#help-text-1').slideUp(250);
    $('#help-text-2').slideUp(250);
    $('#help-text-4').slideDown(250);
})

$('#employment-option-1, #employment-option-2, #employment-option-3, #employment-option-4, #employment-option-7').on('click', function (event) {
    $('#help-text-1').slideUp(250);
    $('#help-text-2').slideUp(250);
    $('#help-text-4').slideUp(250);
})

//cash advance status help text slider logic
$(document).on('change', '[name=cash_advance]', function (event) {
var input = $(event.target);
var value = input.val();
if (value == 'true') {
    $('#help-text-3').slideDown(250);
} else {
    $('#help-text-3').slideUp(250);
}
})

//cash advance status help text slider logic
$(document).on('click', 'div[data-value="debt_consolidation"]', function (event) {
    $('#help-text-3').slideDown(250);
})